import {__} from '../lang/translator'

//チェックボックスの状態変化で検索条件をもとに該当物件数を取得する関数
export const getOfficeCount = async (searchCondition) => {

  try {
    // 検索条件をコントローラに投げる
    const res = await axios.post(route('web.search.count'), searchCondition)

    //該当件数を表示
    displayOfficeCount(res.data.count);

  } catch (error) {

    console.log(error)

  }
}

//該当件数を表示する関数
const displayOfficeCount = (count) => {

  const searchCountArea = document.querySelector('.search-count');
  const searchCountAreaCase = document.querySelector('[data-search-footer-count-case]');
  //町一覧モーダルが開いているか
  const modalOfficeCount1 = document.querySelector('[data-remodal-id=modal_1] .modal_office_count');

  //駅一覧モーダルが開いているか
  const modalOfficeCount2 = document.querySelector('[data-remodal-id=modal_2] .modal_office_count');

  // 件数単位の要素を取得
  const modalOfficeCountCase = document.querySelector('[data-modal-office-count-case]');

  // 従来に想定していたファイル以外(TOPページの検索処理)からも displayOfficeCount にアクセスがあるため、DOMが存在しない場合は処理をスルーさせるための条件分岐
  // 返り値から物件数を表示
  if (searchCountArea) searchCountArea.textContent = count;
  if (searchCountAreaCase) searchCountAreaCase.textContent = __('footer_cases_found', count);
  //町一覧モーダル内で町が選択された場合
  if (modalOfficeCount1) modalOfficeCount1.textContent = count;
  //駅一覧モーダル内で駅が選択された場合
  if (modalOfficeCount2) modalOfficeCount2.textContent = count;

  // 件数単位のテキストを更新
  if (modalOfficeCountCase) modalOfficeCountCase.textContent = __('cases_found', count);
}

//タグをクリックした時の処理
const tagClick = (searchCondition, key, condition) => {
  //町名か駅名の場合
  if (key === "address_code" || key === "line_station_code") {
    searchCondition[key] = searchCondition[key].filter(value => value !== condition);
    if (!searchCondition[key].length) {
      delete searchCondition[key];
    }
    //タグを更新
    updateTag(searchCondition);
    //検索条件をもとに該当物件数を取得
    getOfficeCount(searchCondition);
  } else {
    // それ以外の場合
    const checkbox = document.querySelector('input[name="' + key + '"][value="' + condition + '"]');
    checkbox.checked = false;
    checkbox.dispatchEvent(new Event('change'));
  }
}

//検索条件をもとにタグを更新する関数
export const updateTag = (searchCondition) => {
  const tagArea = document.getElementById('search_condition_tag');
  const imageUrl = window.app.closeIconUrl;
  // タグエリアの初期化
  tagArea.innerHTML = '';

  Object.keys(searchCondition).forEach(function (key) {
    searchCondition[key].forEach(function (condition) {
      const tag = document.createElement('a');
      tag.className = 'btn_ro tag-delete-button';
      if (key === "city_code" || key === "service_brand" || key === "capacity_category" || key === "budget_category" || key === "address_code") {
        const conditionArray = condition.split('_');
        tag.innerHTML = '<a  class="btn_ro">' + conditionArray[1] + '<span><img src="' + imageUrl + '" alt="#"></span></a>';
      } else if (key === "line_station_code") {
        const conditionArray = condition.split('_')[1].split('-');
        tag.innerHTML = '<a  class="btn_ro">' + conditionArray[0] + conditionArray[1] + '<span><img src="' + imageUrl + '" alt="#"></span></a>';
      }
      // 都道府県の条件はタグで表示しない
      else if (key === "prefecture") return;
      else {
        tag.innerHTML = '<a  class="btn_ro">' + condition + '<span><img src="' + imageUrl + '" alt="#"></span></a>';
      }
      //タグにクリックイベントを付与
      tag.addEventListener('click', function () {
        tagClick(searchCondition, key, condition);
      });

      tagArea.appendChild(tag);
    });
  });
}

//チェックボックスの状態が変わった際の関数
export const changeCheckbox = async (searchCondition, checkbox) => {
  // 検索条件を更新する
  searchCondition = updateSearchConditions(searchCondition, checkbox);

  // フッターの表記を更新する
  await updateFooter(searchCondition);
}

/**
 * 検索条件を更新する
 *
 * @param searchCondition 検索条件
 * @param checkbox チェックボックス
 * @returns {Object} 更新された検索条件
 */
export const updateSearchConditions = (searchCondition, checkbox) => {

  // チェックボックスがチェックされた場合
  if (checkbox.checked) {
    if (!searchCondition[checkbox.name]) {
      // そのname属性のキーが存在しない場合、新しい配列として初期化
      searchCondition[checkbox.name] = [];
    }
    // nameごとに区別して配列に格納
    searchCondition[checkbox.name].push(checkbox.value);
  }
  // 検索条件に存在し、チェックが外れている場合は検索条件から削除
  else if (searchCondition[checkbox.name]) {
    const index = searchCondition[checkbox.name].indexOf(checkbox.value);

    if (index > -1) {
      searchCondition[checkbox.name].splice(index, 1);
    }

    // もし配列が空になったら、そのキーを削除
    if (searchCondition[checkbox.name].length === 0) {
      delete searchCondition[checkbox.name];
    }

  }

  return searchCondition;
}

/**
 * フッターのタグや該当件数を更新する
 *
 * @param searchCondition 検索条件
 * @returns {undefined}
 */
export const updateFooter = async (searchCondition) => {
  const tagArea = document.getElementById('search_condition_tag');

  // タグエリアがあればタグを更新
  tagArea && updateTag(searchCondition);

  //検索条件をもとに該当物件数を取得
  await getOfficeCount(searchCondition);
}

//検索条件をリセットする関数
export const clearSearchCondition = async (searchCondition, checkboxes) => {
  const tagArea = document.getElementById('search_condition_tag');
  const checkArea = document.querySelectorAll('.check_area');

  // チェックボックスの初期化
  checkboxes.forEach(function (checkbox) {
    checkbox.checked = false;
  });

  // 各チェックエリアから'act'クラスを取り除く
  for (let i = 0; i < checkArea.length; i++) {
    checkArea[i].classList.remove('act');
  }

  //検索画面か検索結果画面かどうか
  if (tagArea) {
    // 検索条件を初期化
    for (let key in searchCondition) {
      if (key === 'prefecture') {
        continue;
      }

      delete searchCondition[key];
    }
    updateTag(searchCondition);
  } else {
    // 住所と駅以外の検索条件を初期化
    for (let key in searchCondition) {
      if (
        key === 'prefecture' ||
        key === 'address_code' ||
        key === 'city_code' ||
        key === 'line_station_code'
      ) {
        continue;
      }

      delete searchCondition[key];
    }
  }

  //検索条件をもとに該当物件数を取得
  await getOfficeCount(searchCondition);
}


//検索条件をもとに物件一覧を取得する関数
export const handleSearch = async (searchCondition) => {
  axios.post(route('web.search.result'), searchCondition)
    .then((response) => {
      // サーバーから受け取ったURLにリダイレクトする
      window.location.href = response.data.url;
    })
}

/**
 * クエリパラメータに含まれる条件を初期条件として設定する
 */
export const searchInit = async (searchCondition) => {
  // 全ての検索条件のチェックボックスを取得
  const checkboxes = document.querySelectorAll('[data-search-container] input[type="checkbox"]');

  // クエリパラメータの条件を取得
  const commonConditions = new URLSearchParams(location.search).getAll('common[]');
  const commonListConditions = new URLSearchParams(location.search).getAll('commonList[]');
  const cityCodeConditions = new URLSearchParams(location.search).getAll('city_code[]');
  const addressCodeConditions = new URLSearchParams(location.search).getAll('address_code[]');
  const lineStationCodeConditions = new URLSearchParams(location.search).getAll('line_station_code[]');

  // 配列の中に指定された要素と同じものがあればチェックボックスにチェックを入れ検索条件を更新する
  const checkIfSomeEqual = (ary, value, checkbox) => {
    if (ary.some((item) => item === value) && !checkbox.checked) {
      checkbox.checked = true;
      searchCondition = updateSearchConditions(searchCondition, checkbox);
    }
  };

  // チェックボックスにないページ特有の条件を追加する
  const addPeculiarConditions = (name, conditions) => {
    if (!searchCondition[name]) searchCondition[name] = [];

    conditions.forEach((condition) => {
      if (!searchCondition[name].includes(condition)) {
        searchCondition[name].push(condition);
      }
    });
  }

  // クエリパラメータの条件を初期条件として設定する
  checkboxes.forEach((checkbox) => {
    checkIfSomeEqual(commonConditions, checkbox.name, checkbox);
    checkIfSomeEqual(commonListConditions, checkbox.value, checkbox);
    checkIfSomeEqual(cityCodeConditions, checkbox.value, checkbox);
    checkIfSomeEqual(addressCodeConditions, checkbox.value, checkbox);
    checkIfSomeEqual(lineStationCodeConditions, checkbox.value, checkbox);
  });

  // モーダルを開いていない状態ではチェックボックスにないページ特有の条件を追加する
  addPeculiarConditions('address_code', addressCodeConditions);
  addPeculiarConditions('line_station_code', lineStationCodeConditions);

  // フッターの表示を更新する
  await updateFooter(searchCondition);
};

/**
 * 各都道府県に画面遷移する際に、全ての検索ページに共通する条件を引き継ぐ
 */
export const prefectureLinkOnClick = () => {
  // 全ての検索ページに共通する条件を取得
  const commonConditionCheckboxes = document.querySelectorAll('[data-search-common-conditions] input[type="checkbox"]');

  // 都道府県リンクがクリックされた際の動作
  document.querySelectorAll('#search_condition_prefecture [data-change-prefecture]').forEach((link) => {
    link.addEventListener('click', (event) => {
      // デフォルトでついているイベントを実行しない
      event.preventDefault();

      // チェックされている要素を取得する
      const checkedBox = Array.prototype.slice.call(commonConditionCheckboxes).filter((checkbox) => {
        return checkbox.checked;
      });

      // 条件をクエリパラメータに追加する
      const params = new URLSearchParams();
      checkedBox.forEach((checkBox) => {
        // checkBox.name がカテゴリ名、checkBox.value が値の場合は commonList[] に追加
        if (checkBox.name === 'service_brand' || checkBox.name === 'capacity_category' || checkBox.name === 'budget_category') {
          params.append('commonList[]', checkBox.value);
        }
        // checkBox.name が値の場合は common[] に追加
        else {
          params.append('common[]', checkBox.name);
        }
      });

      // モバイルサイズとそれ以外でページ内リンクのスクロール先を変える
      const targetDataset = window.innerWidth > 767 ? 'data-anchor' : 'data-mobile-anchor';

      // クエリパラメータをつけた状態でクリックされた都道府県にページ遷移する
      location.href = link.getAttribute('data-change-prefecture') + '?' + params.toString() + '#' + link.getAttribute(targetDataset);
    });
  });
};

/**
 * 全ての都道府県を見るボタンクリックごとに主要都道府県以外の表示・非表示を切り替えるイベントを登録
 */
export const setSubPrefectureAccordionButtonEvent = () => {
  const subPrefecturesAccordionButton = document.querySelector('[data-sub-prefectures-accordion-button]');
  const subPrefecturesAccordion = document.querySelector('[data-sub-prefectures-accordion]');

  if (subPrefecturesAccordionButton && subPrefecturesAccordion) {
    subPrefecturesAccordionButton.addEventListener('click', () => {
      subPrefecturesAccordion.classList.toggle('!hidden');
    });
  }
};
